import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

/* True-LIVE client contract (Gate-1 §F approved): 60s foreground refetch,
   never in background tabs; LIVE is earned per item at payload age <=150s. */
const live = { refetchInterval: 60_000, refetchIntervalInBackground: false } as const;
const slow = { refetchInterval: 300_000, refetchIntervalInBackground: false } as const;

export const useV2Markets = () =>
  useQuery({ queryKey: ["v2-markets"], queryFn: async () => (await api.get("/markets")).data, ...live });

export const useV2Global = () =>
  useQuery({ queryKey: ["v2-global"], queryFn: async () => (await api.get("/markets/global")).data, ...live });

export const useV2History = (hours: number = 24, full: boolean = false) =>
  useQuery({
    queryKey: ["v2-global-history", hours, full],
    queryFn: async () =>
      (await api.get("/markets/global/history", { params: full ? { hours, full: 1 } : { hours } })).data,
    ...slow,
  });

export const useV2MarketPulse = () =>
  useQuery({
    queryKey: ["v2-market-pulse"],
    queryFn: async () => (await api.get("/articles", { params: { category: "markets", limit: 6 } })).data,
    refetchInterval: 60_000, refetchIntervalInBackground: false,
  });

export const useV2Sparks = () =>
  useQuery({
    queryKey: ["v2-market-sparks"],
    queryFn: async () => (await api.get("/markets/sparks")).data,
    staleTime: 300_000,
  });

export const useV2Movers = () =>
  useQuery({
    queryKey: ["v2-movers"],
    queryFn: async () => (await api.get("/markets/movers", { params: { limit: 6 } })).data,
    refetchInterval: 120_000, refetchIntervalInBackground: false,
  });

export const useV2Sectors = () =>
  useQuery({ queryKey: ["v2-sectors"], queryFn: async () => (await api.get("/sectors/activity")).data, staleTime: 120_000 });

export const useV2LayerIndex = () =>
  useQuery({ queryKey: ["v2-layer-index"], queryFn: async () => (await api.get("/layer-index")).data, ...slow });

export const useV2FearGreed = () =>
  useQuery({ queryKey: ["v2-fear-greed"], queryFn: async () => (await api.get("/markets/fear-greed")).data, ...slow });

export const useV2Stablecoins = () =>
  useQuery({ queryKey: ["v2-stablecoins"], queryFn: async () => (await api.get("/markets/stablecoins")).data, ...slow });

export const useV2LayerHistory = (days = 14) =>
  useQuery({
    queryKey: ["v2-layer-history", days],
    queryFn: async () => (await api.get("/layer-index/history", { params: { days } })).data,
    ...slow,
  });
